// extracted by mini-css-extract-plugin
module.exports = {"image":"ifit-module--image--3jF30","content":"ifit-module--content--1yWW8"};